// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".osui-breadcrumb{font-size:14px}.osui-breadcrumb.ant-breadcrumb>span:last-child:not(:first-child){font-weight:var(--breadcrumb-last-child-font-weight)}.osui-breadcrumb-ellipsis{cursor:pointer}.osui-breadcrumb.ant-breadcrumb a:hover{color:var(--link-hover-color)}.osui-breadcrumb.ant-breadcrumb a:active{color:var(--link-active-color)}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
